import React from 'react';
import useDocumentHead from '~/helpers/use-document-head';
import useLayoutContext from '~/contexts/layout';
export default function Page() {
    useDocumentHead({
        title: '404 Not Found - OpenStax',
        noindex: true
    });
    const { layoutParameters, setLayoutParameters } = useLayoutContext();
    React.useEffect(() => {
        if ((layoutParameters === null || layoutParameters === void 0 ? void 0 : layoutParameters.name) === null) {
            setLayoutParameters === null || setLayoutParameters === void 0 ? void 0 : setLayoutParameters();
        }
    }, [layoutParameters === null || layoutParameters === void 0 ? void 0 : layoutParameters.name, setLayoutParameters]);
    return (React.createElement("main", { className: "not-found no-style page" },
        React.createElement("img", { className: "strips", src: "/dist/images/components/strips.svg", height: "10", alt: "", role: "presentation" }),
        React.createElement("div", { className: "boxed" },
            React.createElement("h1", null, "Uh-oh, no page here"),
            React.createElement("p", null, "Kudos on your desire to explore! Unfortunately, we don't have a page to go with that particular location."))));
}
